import {ChangeDetectionStrategy, Component, effect, input, output} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {PluginDetails} from '../../../../../api';
import {TextInput} from '../../../../components/text-input/text-input';
import {Label} from '../../../../components/label/label';
import {PluginFormValue} from '../../models/plugin-form-value';

@Component({
  selector: 'elcia-plugin-form',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslatePipe, TextInput, Label],
  templateUrl: './plugin-form.html',
})
export class PluginForm {
  initialValue = input<PluginDetails | undefined>();
  onSubmit = output<PluginFormValue>();

  protected form = new FormGroup({
    nameFr: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    nameEn: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    nameNl: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    // Stable identifier: read-only, shown only in edit and never editable.
    guid: new FormControl({value: '', disabled: true}, {nonNullable: true}),
  });

  onInitialValueChange = effect(() => {
    const val = this.initialValue();
    if (!val) {
      this.form.reset();
      return;
    }

    this.form.patchValue({
      nameFr: val.nameFr,
      nameEn: val.nameEn,
      nameNl: val.nameNl,
      guid: val.guid ?? '',
    });
  });

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const formValue = this.form.getRawValue();
    this.onSubmit.emit({
      id: this.initialValue()?.id ?? null,
      nameFr: formValue.nameFr,
      nameEn: formValue.nameEn,
      nameNl: formValue.nameNl,
      guid: formValue.guid.trim() || null,
    });
  }
}
